import API from "../shared/API/apiClient";

export const getDepartmentDistribution = (
  reporting_year,
  filter_type = "",
  from_date = "",
  to_date = "",
  legal_entity_id = "",
  reporting_year_id = ""
) => {
  return API.get("/api/reports/department-distribution", {
    params: {
      reporting_year,
      filter_type,
      from_date,
      to_date,
      legal_entity_id,
      reporting_year_id,
    },
  });
};